function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 18s6-7.714 6-12-2.923-6-6-6-6 1.714-6 6 6 12 6 12zM8 6a2 2 0 11-4 0 2 2 0 014 0z",
  fill: "#A0AFBE"
});
function SvgLocationGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    fill: "none"
  }, props), _ref);
}
export default SvgLocationGray;